<template>
    <v-autocomplete
            :label="(label)? label : 'Usuario'"
            :items="items"
            :value="value"
            :multiple="multiple"
            :small-chips="chips"
            :chips="chips"
            :error-messages="errores.collect('user')"
            :box="box"
            :prepend-icon="prependIcon"
            v-validate="validate"
            data-vv-name="user"
            item-value="id"
            item-text="name"
            item-avatar="avatar"
            hide-details
            hide-selected
            clearable
            @input="actualizaValor($event)"
            @change="change($event)"
    >
        <template slot="selection" slot-scope="{ parent, item, index }">
            <v-chip
                    v-if="chips"
                    :selected="item.selected"
                    :key="JSON.stringify(item)"
                    close
                    class="chip--select-multi"
                    @input="parent.selectItem(item)"
            >
                <v-avatar>
                    <img :src="(item.avatar)? item.avatar : 'img/user-image.png'">
                </v-avatar>
                {{ item.name }}
            </v-chip>
            <span v-if="!chips">{{ (index > 0)? ', ': '' }}{{ item.name }}</span>
        </template>
        <template slot="item" slot-scope="data">
            <v-list-tile-avatar>
                <img :src="(data.item.avatar)? data.item.avatar : 'img/user-image.png'">
            </v-list-tile-avatar>
            <v-list-tile-content>
                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                <v-list-tile-sub-title v-html="data.item.department"></v-list-tile-sub-title>
            </v-list-tile-content>
        </template>
    </v-autocomplete>
</template>
<script>
    import mixinUser from '../mixins/auth/users';

    export default {
        mixins: [mixinUser],
        inject: ['$validator'],
        name: 'user-select',
        props: ['multiple', 'label', 'filtro', 'value', 'chips', 'validate', 'box', 'prependIcon'],
        data() {
            return {
                items: []
            }
        },
        mounted() {
            this.usersList(r => {
                this.items = r;
            }, err => {
                console.log(err);
            })
        },
        methods: {
            actualizaValor(valor) {
                this.$emit('input', valor);
            },
            change(e) {
                this.$emit('change', e);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/UserSelect.vue